export const namespaced = true;

export const state = {
    notifications: []
}

let nextId = 1;

export const mutations = {
    PUSH(state, notification) {
        if (notification && notification.element && !notification.type) {
            notification = { ...notification, type: notification.element };
        }
        state.notifications.push({
            ...notification,
            id: nextId++
        })
    },
    REMOVE(state, notificationToDelete) {
        state.notifications = state.notifications.filter(notification => notification.id !== notificationToDelete.id)
    }
}

export const actions = {
    add({ commit }, notification) {
        commit('PUSH', notification);
    },
    remove({ commit }, notificationToDelete) {
        commit('REMOVE', notificationToDelete);
    }
}
